import type { PopoverProps } from 'primevue/popover'

/**
 * Props interface for the TwnPopover component.
 * Extends PrimeVue PopoverProps with Twine-specific defaults.
 */
interface TwnPopoverProps extends /* @vue-ignore */ PopoverProps {
  /**
   * Whether to append the popover to the body.
   */
  appendTo?: string | HTMLElement
}

const DEFAULT_TWN_POPOVER_PROPS = {
  appendTo: 'body'
} as const

export type { TwnPopoverProps }
export { DEFAULT_TWN_POPOVER_PROPS }
